import React, { FC } from 'react'
import ClientCipCode from '../../clientCipcode/ClientCipcode'
import { IClientInfo } from '../../../interfaces/IClientDetails'

const ClientInfo: FC<IClientInfo> = ({ name, code }) => {
  return (
    <>
      {name && ` - ${name} `}
      {code && (
        <ClientCipCode
          isVisible={true}
          cipCode={code}
          hasParenthesis={[true, true]}
        />
      )}
    </>
  )
}

export default ClientInfo
